import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';

export class Projectable {
  templateRef: TemplateRef<any>;
  viewContainerRef: ViewContainerRef;
}

@Directive({
  selector: '[pgProjectable], [projectable], [gritProjectable]',
  providers: [
    {
      provide: Projectable,
      useExisting: PgProjectableDirective,
      multi: true,
    },
  ],
})
export class PgProjectableDirective implements Projectable {
  constructor(
    public templateRef: TemplateRef<any>,
    public viewContainerRef: ViewContainerRef
  ) {}
}
